// extracted by mini-css-extract-plugin
export default {"rating":"pL-z","numberOfStars":"qL-z","count":"rL-z","barGraphSpacing":"sL-z","barGraph":"tL-z"};